// src/lib/controle-bilan-api.js — client de l'action serveur `controle_bilan`
// (vue « Le bilan » de l'écran Contrôle, maquette Dimitri 2026-08-21).
// UN appel par mois affiché : agrégats calculés SERVEUR (totaux, catégories,
// par logement, par agent) + liste légère des contrôles (0 photo ici — les
// photos ne se signent qu'à l'ouverture d'un détail).

import { supabase } from '../supabase'

export async function fetchControleBilan({ month } = {}) {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.access_token) throw new Error('session requise')
  const res = await fetch('/api/beds24-mapping', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ action: 'controle_bilan', ...(month ? { month } : {}) }),
  })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body.error || `HTTP ${res.status}`)
  }
  return res.json()
}
